/* tslint:disable */
/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */
import styled from '@emotion/styled';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Footer from './Footer';
import Header from './Header';
import HeaderContext, { APPROX_HEADER_HEIGHT, HEADER_PROPS } from './HeaderContext';
import { LegalInfo } from '@kindur/components';
import Sidebar from './Sidebar';
import { useAnimationFrame } from './useAnimationFrame';

import fonts from '../../styles/fonts';

import '../../styles/global';

const overrideBgColor = `
  html, body {
    background-color: #011F1D !important;
  }
`;

const Container = styled('div')`
  background-color: #fff;
  overflow-x: hidden;
`;
const BannerContainer = styled('div')``;
const Main = styled('main')`
  margin: auto;
`;

/* tslint:disable */
// @ts-ignore
const Layout = (props) => {
  const { children, hideFooter, location = { pathname: '', search: '' } } = props;

  const [fixNav, setFixNav] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(APPROX_HEADER_HEIGHT);
  const [headerProps, setHeaderProps] = useState(HEADER_PROPS);
  const [isSidebarVisible, setSidebarVisible] = useState(false);

  // Watch for scrolling events to apply `position: fixed` to navbar
  useAnimationFrame(() => {
    setFixNav(window.scrollY > headerProps.bannerHeight);
  });

  const onClickOutsideSidebar = () => {
    setSidebarVisible(false);
  };

  return (
    <Container>
      <Helmet>
        <style type={`text/css`}>{fonts}</style>
        <style type={`text/css`}>{overrideBgColor}</style>
      </Helmet>
      <Sidebar
        headerHeight={headerHeight}
        location={location}
        targets={{}}
        setSidebarVisible={setSidebarVisible}
        show={isSidebarVisible}
        key={`sidebar`}
      />
      <BannerContainer id={`banner-container`}>
        <Header
          targets={{}}
          bannerHeight={headerProps.bannerHeight}
          {...{
            fixNav: false,
            isSidebarVisible,
            location,
            setSidebarVisible
          }}
        />
      </BannerContainer>
      <HeaderContext.Provider value={headerHeight}>
        <Main id={`main`} onClick={onClickOutsideSidebar}>
          {children}
        </Main>
      </HeaderContext.Provider>
      {!hideFooter && (
        <Footer showContactUsFooter={false} showContactContainer={false}>
          <LegalInfo />
        </Footer>
      )}
    </Container>
  );
};
/* tslint:enable */

export default Layout;
